module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": "",
      "height": "100%"
    }
  }, [_c('v-card-text', {
    staticClass: "ma-0 pa-0"
  }, [_c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "height": "calc(100vh - 550px)",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "30px"
    }
  }, [_vm._v("Nr")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "30px"
    }
  }, [_vm._v("Öffentlich")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Farbe")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kalender), function(item, itemObjKey) {
    return (item !== 'kalender') ? _c('tr', {
      key: itemObjKey
    }, [_c('td', [_vm._v(_vm._s(item.nummer))]), _vm._v(" "), _c('td', [(item.isPublic) ? _c('v-icon', [_vm._v("group")]) : _c('v-icon', [_vm._v("block")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', {
      style: ('background-color: ' + item.farbe + ';')
    }, [_vm._v(_vm._s(item.farbe.hex))]), _vm._v(" "), _c('td', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          (_vm.neuerKalender = item) && (_vm.istNeu = false)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)]) : _vm._e()
  }), 0)])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "disabled": !_vm.istNeu,
      "hint": "Der Name kann später nicht mehr geändert werden!",
      "outlined": "",
      "label": "Name"
    },
    model: {
      value: (_vm.neuerKalender.name),
      callback: function($$v) {
        _vm.$set(_vm.neuerKalender, "name", $$v)
      },
      expression: "neuerKalender.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "type": "number",
      "label": "Nummer"
    },
    model: {
      value: (_vm.neuerKalender.nummer),
      callback: function($$v) {
        _vm.$set(_vm.neuerKalender, "nummer", $$v)
      },
      expression: "neuerKalender.nummer"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "label": "Öffentlich (Der Kalender ist für alle Mitglieder sichtbar und kann abonniert werden. Ansonsten nur für Inhaber von Ämtern sichtbar.)"
    },
    model: {
      value: (_vm.neuerKalender.isPublic),
      callback: function($$v) {
        _vm.$set(_vm.neuerKalender, "isPublic", $$v)
      },
      expression: "neuerKalender.isPublic"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-color-picker', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "flat": "",
      "mode": "hexa",
      "hide-mode-switch": "",
      "hide-canvas": "",
      "swatches": _vm.swatches,
      "show-swatches": ""
    },
    model: {
      value: (_vm.neuerKalender.farbe),
      callback: function($$v) {
        _vm.$set(_vm.neuerKalender, "farbe", $$v)
      },
      expression: "neuerKalender.farbe"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-alert', {
    attrs: {
      "border": "bottom",
      "color": "accent",
      "colored-border": "",
      "type": "warning",
      "icon": "warning"
    }
  }, [_vm._v("\n          Einmal erstellte Kalender können nicht mehr umbenannt oder gelöscht werden!\n        ")])], 1), _vm._v(" "), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        (_vm.neuerKalender = {}) && (_vm.istNeu = true)
      }
    }
  }, [_c('v-icon', [_vm._v("settings_backup_restore")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "icon": "",
      "dark": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        return _vm.addKalender()
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22acb9b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/Kalender.vue
// module id = 742
// module chunks = 15